<template>
  <div
    class="story-container"
    :style="{'background-image': `url(${story.thumbnail})`}"
    @click="openStory"
  />
  <story-modal
    v-model:is-open="isOpen"
    :url="story.storyUrl"
  />
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { ChallengeStory } from '../../types/Story';
import StoryModal from './StoryModal.vue';

interface Props {
  story: ChallengeStory;
}
defineProps<Props>();

const isOpen = ref(false);
function openStory() {
  isOpen.value = true;
}
</script>

<style lang="scss" scoped>
.story-container {
  width: 141px;
  height: 196px;
  overflow: hidden;
  display: block;
  border-radius: 4px;
  background-size: cover;
  flex-grow: 1;
  flex-shrink: 0;
  box-shadow: 2px 2px 8px 0 rgba(186, 188, 191, 0.25);
}
</style>
